import { Typography } from "@mui/material";
import { FC } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_ERROR } from "shared/theme/colors";
import { WarnIcon } from "shared/theme/icons/WarnIcon";

type UnpublishedWarnProps = {
  totalChanges?: number;
};

const UnpublishedWarn: FC<UnpublishedWarnProps> = ({ totalChanges }) => {
  const changesCount = totalChanges ?? "";

  return (
    <FlexCenter
      gap="0.25rem"
      alignSelf="flex-end"
      width="100%"
      position="absolute"
      bottom="-25px"
    >
      <div>
        <WarnIcon color={COLOR_ERROR} />
      </div>
      <Typography
        variant="bodyMRegular"
        color={COLOR_ERROR}
        whiteSpace="nowrap"
      >
        {changesCount} unpublished changes
      </Typography>
    </FlexCenter>
  );
};

export default UnpublishedWarn;
